import styled from 'styled-components';
import { LG_COLOR } from './constants';

export const AppStyles = styled.div`
  display: flex;

  .app-container {
    flex: 1;
    min-width: 0;
    .exit-icon {
      position: absolute;

      z-index: 10;
      font-size: 1.5em;
      color: ${LG_COLOR};
      cursor: pointer;
    }
  }
`;
